import React, { useEffect, useState } from "react";
import { FormularioPerfil } from "../../components/Vecino/FormularioPerfil";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { selectUser, logout } from "../../reducers/userSlice";
import { useForm } from "../../hooks/useForm";
import { buscarVecinoRut, editarVecino } from "../../utils/Datos";
import { LoadingSpinner } from "../../components/Otros/LoadingSpinner";
import Swal from "sweetalert2";

export const EditarPerfil = () => {
  const user = useSelector(selectUser);
  return <div className="container post">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header my-5">
              <div className="card-title mt-5">
                <h3 className="text-gray-700 mb-md-5">Editar Perfil</h3>
              </div>
            </div>
            <div className="card-body pt-0">
              <FormularioPerfil modo="editar_perfil" neighbour_id={user.user.neighbour_id}></FormularioPerfil>
            </div>
          </div>
        </div>
      </div>
    </div>
  
};
